import { render, staticRenderFns } from "./CtrlMessageDialog.vue?vue&type=template&id=7176a9aa&scoped=true&"
import script from "./CtrlMessageDialog.vue?vue&type=script&lang=ts&"
export * from "./CtrlMessageDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CtrlMessageDialog.vue?vue&type=style&index=0&id=7176a9aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7176a9aa",
  null
  
)

export default component.exports